import { useState, useEffect, createContext, useContext } from 'react';
import { authApi, getToken, setToken, getUser, setUser } from '../api/auth';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUserState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = getToken();
      const storedUser = getUser();
      if (token && storedUser) {
        try {
          const currentUser = await authApi.getCurrentUser();
          setUserState(currentUser);
          setUser(currentUser); // Update stored user
        } catch (error) {
          // Token invalid, clear storage
          setToken(null);
          setUser(null);
          setUserState(null);
        }
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  const login = async (email, password) => {
    const response = await authApi.login(email, password);
    setToken(response.token);
    setUser(response.user);
    setUserState(response.user);
    return response;
  };

  const logout = async () => {
    await authApi.logout();
    setUserState(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
